import { Badge } from "antd";

export const TeamChannelPreview = ({ name, unread }) => (<div className='channel-preview__item  justify-between items-center text-left'>
  <p>{`# ${name}`}         </p>
  <Badge showZero={false} className=' text-grey' style={{ color: 'crimson' }} count={unread} color={unread === 0 ? "#EF8100" : "white"} />

  </div>);
